(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-products-scroll"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('all-products-scroll')) {
  class AllProductsScroll extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      if (!this.dataset.nextUrl) return;

      const start = () => this.loadRemaining();
      if (!('IntersectionObserver' in window)) {
        start();
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        start();
      }, { rootMargin: '600px' });
      observer.observe(this);
    }

    disconnectedCallback() {
      this.cancelled = true;
    }

    async loadRemaining() {
      const grid = this.querySelector('[data-products-grid]');
      const status = this.querySelector('[data-scroll-status]');
      if (!grid) return;

      if (status) status.hidden = false;

      const seenPages = new Set(['1']);
      let next = this.dataset.nextUrl;
      let guard = 0;

      while (next && guard < 40 && !this.cancelled) {
        guard += 1;
        const nextUrl = new URL(next, window.location.href);
        const page = nextUrl.searchParams.get('page');
        if (!page || seenPages.has(page)) break;
        seenPages.add(page);

        const url = new URL(window.location.href);
        url.searchParams.set('page', page);
        url.searchParams.set('section_id', this.dataset.sectionId);

        let html = '';
        try {
          const response = await fetch(url.toString(), { credentials: 'same-origin' });
          if (!response.ok) break;
          html = await response.text();
        } catch (error) {
          break;
        }

        if (this.cancelled || !this.isConnected) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = doc.querySelectorAll('[data-products-grid] > li:not(.swiper-slide-duplicate)');
        if (!items.length) break;

        const host = this.querySelector('product-swiper');
        if (host && typeof host.destroySwiper === 'function') host.destroySwiper();

        const existing = new Set(
          [...grid.querySelectorAll('[data-product-id]')].map((item) => item.dataset.productId)
        );
        let added = 0;

        items.forEach((item) => {
          const id = item.dataset.productId;
          if (id && existing.has(id)) return;
          if (id) existing.add(id);
          grid.appendChild(document.importNode(item, true));
          added += 1;
        });

        if (host && typeof host.initSwiper === 'function') host.initSwiper();
        if (added === 0) break;

        const source = doc.querySelector('all-products-scroll');
        next = source && source.dataset.nextUrl ? source.dataset.nextUrl : '';
      }

      if (status) status.hidden = true;
      this.refreshSwiper();
    }

    refreshSwiper() {
      const host = this.querySelector('product-swiper');
      if (!host || typeof host.refresh !== 'function') return;
      host.refresh();
    }
  }

  customElements.define('all-products-scroll', AllProductsScroll);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
  class FooterMenu extends HTMLElement {
    constructor() {
      super();
      this.menus = this.querySelectorAll('details-disclosure');
      this.resetHandler = this.reset.bind(this);
      setTimeout(this.resetHandler, 50);
    }

    connectedCallback() {
      window.addEventListener('on:breakpoint-change', this.resetHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('on:breakpoint-change', this.resetHandler);
    }

    reset() {
      this.menus.forEach((menu) => {
        if (theme.mediaMatches.lg) {
          if (!menu.disclosure.open) {
            menu.open();
          }
          menu.toggle.setAttribute('tabindex', '-1');
        } else {
          if (menu.disclosure.open) {
            menu.close();
          }
          menu.toggle.removeAttribute('tabindex');
        }
      });
    }
  }

  customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gold-ruling"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-gold-ruling-play]');
    if (!trigger) return;

    var src = trigger.getAttribute('data-embed-src');
    var wrap = trigger.closest('.gold-ruling__media');
    if (!src || !wrap) return;

    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = trigger.getAttribute('data-title') || 'Video';
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('frameborder', '0');
    wrap.replaceChildren(iframe);
  });

  } catch(e) { console.error(e); }
})();
})();
